import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthorizedServicesProcedur } from '../models/models'

export class DeleteAuthorizedServicesProcedurApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesProcedur/delete/',
      requesterInfo,
    })
  }

  public async deleteAuthorizedServicesProcedur(id: number): Promise<IAuthorizedServicesProcedur[]> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<IAuthorizedServicesProcedur[]>()
  }
}
